import type { WeaponDef } from '../../sim/defs';

/** A00 — VULCAN. L'arme de série (PLAN.md §6.3).
 *
 *  10 volées/s × 2 projectiles × 10 dégâts = 200 DPS. C'est l'unité de mesure
 *  de tout l'équilibrage du jeu : les points de vie du bestiaire, la courbe de
 *  puissance des cartes et le plafond de DPS des secondaires se lisent tous en
 *  fraction de ce nombre.
 *
 *  ── Pourquoi son profil est VIDE ──────────────────────────────────────────
 *  `BASE_STATS` DÉCRIT déjà le VULCAN. Recopier 10/2/10 ici en modificateurs
 *  donnerait deux sources pour le même chiffre, et la question insoluble de
 *  savoir laquelle fait autorité le jour où l'une bouge. `validateWeapons`
 *  refuse tout modificateur sur cette arme.
 *
 *  ── Sa place dans le triangle ─────────────────────────────────────────────
 *  Ni la plus dense, ni la plus lourde : la plus RAPIDE. Ses projectiles à
 *  1 800 u/s sont ceux qui atteignent le haut de l'écran le plus tôt, donc les
 *  seuls qui touchent un ennemi avant qu'il ait fini d'entrer en scène. Espace
 *  de colonne 180 u — exactement entre les 450 u du PLASMA et les 67,5 u du
 *  FAISCEAU. */
const vulcan: WeaponDef = {
  id: 'vulcan',
  name: 'VULCAN',
  modifiers: [],
  text: '10 volées/s × 2 × 10 dégâts — 200 DPS, projectiles à 1 800 u/s',
};

export default vulcan;
